import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { StorageInterface } from '../storage.interface';

@Injectable({ providedIn: 'root' })
export class LocalService implements StorageInterface {
  constructor(private readonly storage: LocalStorageService) {}

  public set(key: string, value: any): void {
    this.storage.store(key, value);
  }

  public get(key: string): any {
    return this.storage.retrieve(key);
  }

  public remove(key: string): void {
    this.storage.clear(key);
  }
}
